module.exports = __webpack_public_path__ + "img/graf_dm_pink.f6921229.svg";